'use strict';

import { environment } from '@quartz-iam-legacy/environments/environment';

angular.module('services.employees', [])

.factory('employeeService', ['$http', '$q', function ($http, $q) {

    var service = {};
    var baseUrl = environment.apiUrl + '/ID/API/Employee';
    var baseUrl2 = environment.apiUrl + '/ID/Employee/API';
    var externalIdentityBaseUrl = environment.apiUrl + '/ID/API/Employee/External';

    service.getEmployeeBasicInfos = function (employeeId, cache) {
        if (!_.isBoolean(cache)) cache = true;

        return $http.get(baseUrl + '/' + employeeId + '/BasicInfos',
                         { cache: cache });
    };

    service.getPendingEmployeeBasicInfos = function (employeeId) {
        return $http
                .get(baseUrl2 + '/' + employeeId + '/Pending/BasicInfos');
    };

    service.getBasicInfosOnEmployeeOrMatchingEmployee = function (eventGroupId) {
        return $http
                .get(baseUrl2 + '/EmployeeOrMatching/ByEventGroup/' + eventGroupId + '/BasicInfos');
    };

    service.getMoreInfosOnEmployeeByID = function (employeeId) {
        return $http
                .get(baseUrl2 + '/' + employeeId + '/MoreInfos', { cache: true })
                .then(function (response) { return response.data; });
    };

    service.getEmployeeIDByAuthentication = function () {
        return $http
            .get(baseUrl2 + '/Identity', { cache: true })
            .then(function (response) { return response.data; })
    };

    service.getEmployeePositionInHierarchy = function (employeeId) {
        return $http.get(baseUrl2 + '/' + employeeId + '/PositionInHierarchy', { cache: true });
    };

    service.getPositionInHierarchyPresident = function () {
        return $http
            .get(baseUrl2 + '/President/PositionInHierarchy', { cache: true })
            .then(function (response) { return response.data; });
    };

    // Check Windows Account
    service.checkWindowsAccount = function (firstName, lastName) {
        return $http
            .post(baseUrl + '/WindowsAccount/Check', {
                firstName: firstName,
                lastName: lastName
            })
            .then(function (response) { return response.data; });
    };

    // Check Correct Windows Account
    service.checkCorrectWindowsAccount = function (activeDirectoryAccountUsername) {
        return $http
            .post(baseUrl + '/WindowsAccount/CheckCorrect', {
                activeDirectoryAccountUsername: activeDirectoryAccountUsername
            })
            .then(function (response) { return response.data; });
    };

    // System Owner
    service.getEmployeesWithPendingsBySystemOwner = function (authLogin) {
        var resUrl = baseUrl2 + '/BySystemOwner/' + authLogin + '/Employee/WithPendings/NumberOf';

        return $http.get(resUrl)
                    .then(function (response) {
                        return response.data;
                    });
    }

    // System Owned - System Ownership
    service.addNewBackupSystemOwner = function (authLogin, backupEmployeeId, systems) {
        var systemIdList = _.map(systems, 'SystemID');

        return $http
                .post(baseUrl2 + '/BySystemOwner/' + authLogin + '/SystemOwner/Backup', {
                    backupEmployeeId: backupEmployeeId,
                    systemIdList: systemIdList
                })
                .then(function (response) {
                    return response.data;
                });
    };

    service.removeBackupSystemOwner = function (authLogin, backupEmployeeId, systems) {
        var systemIdList = _.map(systems, 'SystemID');

        return $http
                .post(baseUrl2 + '/BySystemOwner/' + authLogin + '/SystemOwner/Backup/Remove', {
                    backupEmployeeId: backupEmployeeId,
                    systemIdList    : systemIdList
                })
                .then(function (response) {
                    return response.data;
                });
    };

    service.replaceBackupSystemOwners = function (authLogin, backupEmployees, systems) {
        var backupEmployeeIdList = _.map(backupEmployees, 'EmployeeID');
        var systemIdList = _.map(systems, 'SystemID');

        return $http
                .post(baseUrl2 + '/BySystemOwner/' + authLogin + '/SystemOwner/Backup/Replace', {
                    backupEmployeeIdList: backupEmployeeIdList,
                    systemIdList        : systemIdList
                })
                .then(function (response) {
                    return response.data;
                });
    };

    service.changePrimarySystemOwner = function (authLogin, primaryEmployeeId, systems) {
        var systemIdList = _.map(systems, 'SystemID');

        return $http
                .post(baseUrl2 + '/BySystemOwner/' + authLogin + '/SystemOwner/Primary', {
                    newPrimaryEmployeeId: primaryEmployeeId,
                    systemIdList        : systemIdList
                })
                .then(function (response) {
                    return response.data;
                });
    };


    // System Owned - Default Entitlements
    service.addDefaultEntitlement = function (authLogin, employeeId, systemRoleId) {
        return $http.post(baseUrl2 + '/' + employeeId + '/BySystemOwner/' + authLogin +
                         '/SystemRole/' + systemRoleId + '/DefaultEntitlement', {})
                    .then(function (response) {
                        return response.data;
                    });
    };

    service.removeDefaultEntitlement = function (authLogin, employeeId, systemRoleId) {
        return $http.delete(baseUrl2 + '/' + employeeId + '/BySystemOwner/' + authLogin +
                 '/SystemRole/' + systemRoleId + '/DefaultEntitlement');
    };

    // Arrival
    service.getNotProcessedEventsArrivalEmployees = function (activeDirectoryAccountUsername) {
        return $http.get(baseUrl2 + '/Event/ArrivalEmployee/NotProcessed/ForSupervisor/' + activeDirectoryAccountUsername)
                    .then(function (response) {
                        return response.data;
                    });
    }

    // Synchronization
    service.synchronizeAllActiveEmployees = function () {
        return $http.post(baseUrl2 + '/SyncAll');
    }

    service.synchronizeAllExternalEmployees = function () {
        return $http.post(externalIdentityBaseUrl + '/SyncAll');
    }

    return service;
}]);
